import React, { Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader.jsx";

const EnhancedSearchResults = React.lazy(
  () =>
    import(
      "../../components/enhancedSearch/SearchResults/EnhancedSearchResults.jsx"
    ),
);
const AppSearchHeader = React.lazy(
  () =>
    import("../../components/enhancedSearch/AppSearchPage/AppSearchHeader.jsx"),
);
const TopicToolsSticky = React.lazy(
  () => import("../../components/topicToolsSticky.jsx"),
);

const EnhancedSearchResultsPageApp = ({
  isWebModernisationEnabled,
  isAppMode,
}) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);
  const searchParams = new URLSearchParams(search);

  return (
    <div id="tgsearch">
      <Suspense fallback={<Loader isAppMode={true} />}>
        <AppSearchHeader
          navigate={navigate}
          initialSearchTerm={searchParams.get("appendedinputbuttons")}
        ></AppSearchHeader>

        <div className="container">
          <EnhancedSearchResults
            navigate={navigate}
            search={search}
            isAppMode={isAppMode}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            isWebModernisationEnabled={isWebModernisationEnabled}
          />
        </div>
        <TopicToolsSticky pathname={pathname} />
      </Suspense>
    </div>
  );
};

export default EnhancedSearchResultsPageApp;
